enum AddressPart {
  ADDRESS,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
}

export default AddressPart;
